import React from "react"
import styled, { css } from "styled-components"
import { Section, SectionTitle, P, H } from "../../components"
import { COLORS, IMAGES } from "../../constants"
import { FaMobileAlt, FaAndroid, FaApple, FaTh, FaHandPointDown } from "react-icons/fa"
import { darken } from "polished"
import { Each } from "cn-react-helpers"
import { Link } from "gatsby"
import LazyLoad from "react-lazyload"

export function Center({ CITY }){
  const Block = styled.div`
    width: 100%;
    max-width: 1200px;
    padding-bottom: 100px;
    margin: 0 auto 100px auto;
    border-bottom: solid ${COLORS.BORDER} 1px;

    @media(max-width: 800px){
      padding-bottom: 50px;
      margin: 0 auto 50px auto;
    }

    ${props => props.noSpace && css`
      padding-bottom: 0px;
      margin: 0 auto 0px auto;
      border-bottom: none;
    `}
  `

  const BlockIcon = ({ icon }) => {
    const Icon = styled(icon)`
      font-size: 60px;
      display: block;
      margin: 0 auto 30px auto;
      color: #AFAFAF;
    `

    return <Icon/>
  }

  const BlockTitle = styled(SectionTitle)`
    margin-bottom: 15px;
  `

  const BlockText = styled(P)`
    text-align: center;
    color: ${COLORS.FONT};
    max-width: 400px;
    margin: 0 auto 50px auto;

    @media(max-width: 800px){
      max-width: 240px;
    }
  `

  // Download

  const Buttons = styled.div`
    width: 100%;
    max-width: 630px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media(max-width: 800px){
      max-width: 280px;
      grid-template-columns: 1fr;
    }
  `

  const DownloadButton = styled.a`
    background-color: ${CITY.COLOR};
    font-size: 1.6em;
    padding: 15px;
    color: ${COLORS.WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    text-decoration: none;
    transition: all 0.3s linear 0s;

    &:hover{
      background-color: ${darken(0.2, CITY.COLOR)};
    }

    @media(max-width: 800px){
      padding: 13px;
      font-size: 1.4em;
    }
  `

  const DownloadButtonIcon = ({ icon }) => {
    const Icon = styled(icon)`
      font-size: 40px;
      color: ${COLORS};
      margin-right: 20px;
    `

    return <Icon />
  }

  // Features

  const Features = styled.section`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;

    @media(max-width: 1200px){
      grid-template-columns: 1fr 1fr;
    }

    @media(max-width: 800px){
      grid-template-columns: 1fr;
      max-width: 500px;
      gap: 10px;
    }
  `

  function Feature({title, text, icon}){
    const Container = styled.div`
      padding: 30px;
      border: solid ${COLORS.BORDER} 1px;
      border-radius: 10px;
    `

    const Icon = styled(icon)`
      color: ${CITY.COLOR};
      font-size: 40px;
      margin-bottom: 20px;
    `

    const Title = styled(H)`
      color: ${COLORS.TITLE};
      margin-bottom: 20px;
    `

    const Text = styled(P)`
      color: ${COLORS.FONT};
    `

    return (
      <Container>
        <Icon />
        <Title> {title} </Title>
        <Text small> {text} </Text>
      </Container>
    )
  }

  // Credits

  const Logos = styled.section`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;

    @media(max-width: 800px){
      gap: 20px;
      max-width: 500px;
    }
  `

  const Logo = styled(Link)`
    padding: 40px;
    border: solid ${COLORS.BORDER} 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    transition: all 0.3s linear 0s;

    &:hover {
      border: solid ${CITY.COLOR} 1px;
    }

    img{
      width: 100%;
    }

    @media(max-width: 800px){
      padding: 30px;
    }
  `

  return (
    <Section>

      {/* Download */}

      <Block>
        <BlockIcon icon={FaMobileAlt} />
        <BlockTitle> {CITY.DOWNLOAD.TITLE} </BlockTitle>
        <BlockText> {CITY.DOWNLOAD.DESCRIPTION} </BlockText>

        <Buttons>
          <DownloadButton target="_blank" href={CITY.DOWNLOAD.ANDROID.LINK}>
            <DownloadButtonIcon icon={FaAndroid} />
            {CITY.DOWNLOAD.ANDROID.TITLE}
          </DownloadButton>

          <DownloadButton target="_blank" href={CITY.DOWNLOAD.IOS.LINK}>
            <DownloadButtonIcon icon={FaApple} />
            {CITY.DOWNLOAD.IOS.TITLE}
          </DownloadButton>
        </Buttons>
      </Block>

      {/* Features */}

      <Block>
        <BlockIcon icon={FaTh} />
        <BlockTitle> {CITY.FEATURES.TITLE} </BlockTitle>
        <BlockText> {CITY.FEATURES.DESCRIPTION} </BlockText>

        <Features>
          <Each items={CITY.FEATURES.ITEMS}>
            {ITEM => (
              <Feature icon={ITEM.ICON} title={ITEM.TITLE} text={ITEM.TEXT} />
            )}
          </Each>
        </Features>
      </Block>

      {/* Credits */}

      <Block noSpace>
        <BlockIcon icon={FaHandPointDown} />
        <BlockText> {CITY.CREDITS.DESCRIPTION} </BlockText>

        <LazyLoad>
          <Logos>
            <Logo to="/mobby">
              <img src={IMAGES.MOBBY_DARK} alt="mobby"/>
            </Logo>

            <Logo to="/">
              <img src={IMAGES.LOGO} alt="mobby"/>
            </Logo>
          </Logos>
        </LazyLoad>
      </Block>

    </Section>
  )
}

